import axiosAPI from './axiosAPI';

import {
    ApiKeyCreatePayload,
    ApiKeyCreateResponse,
    ApiKeyItem,
} from '../models/ApiKey';

/**
 * API-методы для управления API-ключами (D2.12).
 * База — axiosAPI (baseURL = apiAddress = .../api/lk).
 */
export class ApiKeysAPI {
    /**
     * GET /api/lk/api_keys
     * Список ключей пользователя.
     */
    GetKeys(): Promise<ApiKeyItem[]> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .get('/api_keys')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * POST /api/lk/api_keys
     * Создать ключ. Возвращает полный ключ — показывается один раз.
     */
    Create(payload: ApiKeyCreatePayload): Promise<ApiKeyCreateResponse> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .post('/api_keys', payload)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * POST /api/lk/api_keys/{id}/revoke
     */
    Revoke(id: number): Promise<{ status: boolean; message: string }> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .post(`/api_keys/${id}/revoke`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * POST /api/lk/api_keys/{id}/reissue
     * Отзывает старый ключ и выпускает новый. Полный ключ — один раз.
     */
    Reissue(id: number): Promise<ApiKeyCreateResponse> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .post(`/api_keys/${id}/reissue`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
}

export const apiKeysAPI = new ApiKeysAPI();
